export default __webpack_public_path__ + "static/media/logoRedondo.14104028.png";